exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2ze2X{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;margin-bottom:20px;background:#fff;height:45px;padding-left:15px}._3WtQK{-ms-flex:1 1 100%;flex:1 1 100%}._2ufDq,._3WtQK{-webkit-box-flex:1;border:none;outline:none}._2ufDq{-ms-flex:1 0 60px;flex:1 0 60px;background:#ffd906;color:#000;cursor:pointer}._2ufDq:focus,._2ufDq:hover{background-color:#ffc107}._3QNg8{position:absolute;height:100%;width:40px;margin:auto;top:0;right:60px;bottom:0;font-size:25px;line-height:45px;text-align:center;cursor:pointer}._3QNg8:before{content:\"\\D7\"}", ""]);

// exports
exports.locals = {
	"form": "_2ze2X",
	"input": "_3WtQK",
	"submit": "_2ufDq",
	"clean": "_3QNg8"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/SearchInput/SearchInput.css
// module id = 2449
// module chunks = 1 36